import { useEffect, useRef, useState } from "react";
import MessagesContainer from "../../../../messages/messageContainer";
import useGetOrderItemInrixVolumeParams from "../controls/GetOrderItemInrixVolumeParams";
import { useFeatureContext } from "../../../../../../context/Feature";
import { useViewContext } from "../../../../../../context/View/ViewContext";
import { MIN_ZOOM_TO_SHOW_ROADS } from "../MapZoom";
import { Feature } from "ol";

interface OrderItemInrixVolumesMessagesProps {}

const OrderItemInrixVolumesMessages =
  ({}: OrderItemInrixVolumesMessagesProps) => {
    const { selectedFeatures } = useFeatureContext();
    const { view } = useViewContext();
    const zoom = view?.getZoom() ?? 0;

    const [visible, setVisible] = useState(false);

    useEffect(() => {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }, []);

    const getInrixVolumeMessage = ({
      selectedFeatures,
      zoom,
      clearFeatures,
    }: {
      selectedFeatures: Feature[] | null;
      zoom: number;
      clearFeatures: () => void;
    }) => {
      if (zoom <= MIN_ZOOM_TO_SHOW_ROADS) {
        return <>Zoom to show roads</>;
      }

      if (selectedFeatures !== null && selectedFeatures.length > 0) {
        return (
          <div className="mt-2">
            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={() => clearFeatures()}
            >
              Clear Selection
            </button>
          </div>
        );
      } else {
        return <>Click road to see details</>;
      }
    };

    const { clearFeatures } = useFeatureContext();

    return (
      <>
        {visible && (
          <MessagesContainer>
            <div className="rounded bg-light text-black text-center p-2">
              {getInrixVolumeMessage({
                selectedFeatures,
                zoom,
                clearFeatures,
              })}
            </div>
          </MessagesContainer>
        )}
      </>
    );
  };

export default OrderItemInrixVolumesMessages;
